import React from 'react';
const Nopermission=props=>{
    return (
        <div style={{margin:'0 auto',width:'22%', marginTop:'15%'}} className="center red-text">
            <h2 style={{color:'red'}}>No Permission...!</h2>
        </div>
		 );
};
export default Nopermission;





// WEBPACK FOOTER //
// ./src/core/Nopermission.js